/** Yataş Grubu markaları (Glowytics’te aynı dörtlü liste) */
export const YATAS_GROUP_BRAND_IDS = new Set([
  '44e35dfe-0186-495d-a0cc-db5e7e459ab7', // Yataş Bedding
  'dfcf54dd-b00d-434a-be1e-27b6484848eb', // Divanev
  '7fc8e68d-f2ba-4101-95f7-acece386ab8f', // puffy
  'ccb2364b-e4e1-4f7f-944a-44cc9a839c6e', // EnzaHome
]);

/** Kampanya adına göre: önce branding, sonra performance (performans) */
export function yatasCampaignNameBucket(name) {
  const n = String(name || '').toLowerCase();
  if (n.includes('branding')) return 'branding';
  if (n.includes('performance') || n.includes('performans')) return 'performance';
  return 'other';
}

/**
 * @param {'all'|'performance'|'branding'} filter
 */
export function matchesYatasCampaignNameFilter(name, filter) {
  if (!filter || filter === 'all') return true;
  const b = yatasCampaignNameBucket(name);
  if (filter === 'branding') return b === 'branding';
  if (filter === 'performance') return b === 'performance';
  return true;
}

export function filterRowsByYatasCampaignName(rows, brandId, filter, nameGetter) {
  if (!Array.isArray(rows) || !rows.length) return rows;
  if (!YATAS_GROUP_BRAND_IDS.has(brandId) || !filter || filter === 'all') return rows;
  const get = nameGetter || ((r) => r.campaignName || r.campaign_name || r.name || '');
  return rows.filter((r) => matchesYatasCampaignNameFilter(get(r), filter));
}
